import { useBreakpoint } from 'Context/BreakpointsContext/BreakpointsContext';
import { isSSR } from 'Utilities/helpers';

const isExpandableFilterDefault = false;

const useFilterView = () => {
	const {
		minWidth: { breakpointContent: isDesktop },
	} = useBreakpoint();
	const isExpandableFilter = Boolean(isDesktop);

	if (isSSR()) {
		return { isExpandableFilter: isExpandableFilterDefault };
	}

	return { isExpandableFilter };
};

export default useFilterView;
